export const UPDATED_CONTENT_EVENTNAME = "content_updated";

export type InitCallback = (e: HTMLElement) => void;

const delegates: Array<InitCallback> = [];

export function initUpdatedContentIslands() {
    if (!document) {
        console.warn("Missing document instance");
        return;
    }

    document.addEventListener(UPDATED_CONTENT_EVENTNAME, (evt: Event) => {
        const customEvt = evt as CustomEvent<HTMLElement>;
        const elm: HTMLElement = customEvt.detail;
        delegates.forEach((callback) => callback(elm));
    });
}

export function addUpdatedContentDelegate(callback: InitCallback) {
    delegates.push(callback);
}

export function triggerContentUpdated(elm: HTMLElement) {
    const evt = new CustomEvent(UPDATED_CONTENT_EVENTNAME, { detail: elm });
    document.dispatchEvent(evt);
}
